const ukDirectoryBrowse: Record<
  string,
  { message: string; description: string }
> = {
  "ledgerEditor.cloneRepository": {
    message: "Клонувати репозиторій",
    description: "Header for clone repository dialog",
  },
  "ledgerEditor.downloadZip": {
    message: "Вownload ZIP",
    description: "Menu item to download as ZIP",
  },
  "ledgerEditor.manageSshKeys": {
    message: "Керування SSH ключами",
    description: "Menu item for SSH key management",
  },
  "ledgerEditor.thisDirectoryIsEmpty": {
    message: "Ця директорія порожня",
    description: "Message shown when directory has no contents",
  },
};

export default ukDirectoryBrowse;
